<div class="card">
  <div class="card-header d-flex justify-content-between" [ngClass]="{'border-0': !isOpen}">
    <div class="d-flex">
    <p class="fw-bold align-self-center" (click)="toggle()" role="button">{{ cardTitle }}</p>
    <ng-content select="[card-header-content]"></ng-content>
    </div>
    <div (click)="toggle()" class="flex-grow-1"></div>
    <button class="btn btn-light p-0" (click)="toggle()">
      <i class="fa-solid fa-lg" [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
    </button>
  </div>
  @if (isOpen) {
    <div class="card-body">
      <ng-content></ng-content>
    </div>
  }
</div>